"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _excluded = ["tabs", "activeTab", "disabledTab"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Tab = function Tab(_ref) {
  var tabs = _ref.tabs,
      activeTab = _ref.activeTab,
      disabledTab = _ref.disabledTab,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "tabs"
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "nav-tab"
  }, tabs.map(function (tab, i) {
    return /*#__PURE__*/_react.default.createElement("li", _extends({
      key: tab,
      className: activeTab === "tab".concat(i) ? 'active' : disabledTab === true ? 'disabled' : undefined,
      value: i
    }, props), tab);
  })));
};

var _default = Tab;
exports.default = _default;
Tab.propTypes = {
  tabs: _propTypes.default.array.isRequired,
  activeTab: _propTypes.default.string,
  disabledTab: _propTypes.default.bool
};
Tab.defaultProps = {
  activeTab: 'tab0',
  disabledTab: false
};